import { render } from "./SystemCheckScreen.vue?vue&type=template&id=27a542b7&scoped=true"
import script from "./SystemCheckScreen.vue?vue&type=script&lang=js"
export * from "./SystemCheckScreen.vue?vue&type=script&lang=js"

import "./SystemCheckScreen.vue?vue&type=style&index=0&id=27a542b7&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a542b7"]])

export default __exports__